import { ISelectedMovRefObject } from "./../interfaces/Index";
import { PAIYA_GAME_STATUS } from "config/constants";
import {
  IPaiyaConfigPageState,
  IPaiyaMOVGameStatusPayload,
} from "../interfaces/Index";

export const normalizePaiyaType = (request: any): any => {
  const payload: any = {
    games: request.games,
    variants: request.variants,
  };
  let pv = payload.variants;
  let paiyaType = [];
  for (let i = 0; i < pv.length; i++) {
    paiyaType.push({
      id: i,
      value: i,
      label: pv[i],
    });
  }
  return paiyaType;
};

export const normalizePaiyaConfig = (request: IPaiyaConfigPageState): any => {
  const payload: IPaiyaConfigPageState = {
    status: !request.status
      ? PAIYA_GAME_STATUS.INACTIVE
      : PAIYA_GAME_STATUS.ACTIVE,
    requirement: request.requirement,
  };
  return payload;
};

export const normalizePaiyaCsvPayload = (
  giftCsvFile: any,
  storeCsvFile: any
) => {
  let formData = new FormData();
  formData.append("giftCsvFile", giftCsvFile);
  formData.append("storeCsvFile", storeCsvFile);
  return formData;
};

export const normalizePaiyaMovGameStatus = (
  status: boolean,
  selectedMov: ISelectedMovRefObject[],
) => {
  const movDTO = selectedMov.reduce((acc: any, mov: any) => {
    const { title, value } = mov;
    return {
      ...acc,
      [title]: {
        type: "MIN_ORDER_VALUE",
        value,
      },
    };
  }, {});
  const payload: IPaiyaMOVGameStatusPayload = {
    status: !status ? PAIYA_GAME_STATUS.INACTIVE : PAIYA_GAME_STATUS.ACTIVE,
    requirement: {
      ...movDTO,
    },
  };
  return payload;
};
